import { DaoModel } from '@dynameat/models';
import { PredictionState } from './predictionState';

export class PredictionPeriod extends DaoModel {
  constructor(guid, startDate, endDate, isActive, areProductPriceRecommendationsValidated,
    productPriceRecommendationsState, areDemandRecommendationsValidated,
    demandRecommendationsState, areMenuEngineeringRecommendationsValidated,
    hasActiveExperiments, startDateStr, endDateStr) {
    super(guid);
    this.startDate = startDate || new Date(1970, 1, 1);
    this.endDate = endDate || new Date(1970, 1, 1, 23, 59, 59, 999);
    this.isActive = isActive || false;
    this.areProductPriceRecommendationsValidated = areProductPriceRecommendationsValidated || false;
    this.productPriceRecommendationsState = productPriceRecommendationsState || PredictionState.ERROR;
    this.areDemandRecommendationsValidated = areDemandRecommendationsValidated || false;
    this.demandRecommendationsState = demandRecommendationsState || PredictionState.ERROR;
    this.areMenuEngineeringRecommendationsValidated = areMenuEngineeringRecommendationsValidated || false;
    this.hasActiveExperiments = hasActiveExperiments || false;

    // this.startDate.setHours(0, 0, 0, 0);
    this.endDate.setHours(23, 59, 59, 999);
    this.startDateStr = startDateStr || this.startDate.toISOString().split('T')[0];
    this.endDateStr = endDateStr || this.endDate.toISOString().split('T')[0];
    this.isPreviousPeriod = this.endDate < new Date();
  }

  static toInstance(props = {}) {
    const startDate = props.start_date ? PredictionPeriod.applyTimeZoneOffset(new Date(props.start_date)) : null;
    const endDate = props.end_date ? PredictionPeriod.applyTimeZoneOffset(new Date(props.end_date)) : null;
    return new PredictionPeriod(props.guid, startDate, endDate, props.active,
      props.are_product_price_recommendations_validated, props.product_price_recommendations_state,
      props.are_demand_recommendations_validated, props.demand_recommendations_state,
      props.are_menu_engineering_recommendations_validated,
      props.has_active_experiments, props.start_date, props.end_date);
  }

  serialize() {
    return {
      ...super.serialize(),
      start_date: this.startDateStr,
      end_date: this.endDateStr,
      are_product_price_recommendations_validated: this.areProductPriceRecommendationsValidated,
      product_price_recommendations_state: this.productPriceRecommendationsState,
      are_demand_recommendations_validated: this.areDemandRecommendationsValidated,
      demand_recommendations_state: this.demandRecommendationsState,
      are_menu_engineering_recommendations_validated: this.areMenuEngineeringRecommendationsValidated,
      has_active_experiments: this.hasActiveExperiments,
    };
  }

  get startDateLocaleStr() {
    return this.startDate.toLocaleDateString();
  }

  get endDateLocaleStr() {
    return this.endDate.toLocaleDateString();
  }

  get name() {
    return `${this.startDateLocaleStr} - ${this.endDateLocaleStr}`;
  }

  isDemandEditable() {
    return !this.isPreviousPeriod;
  }

  isProductPriceEditable() {
    if (this.isPreviousPeriod) return false;
    if (!this.isActive) return true;
    return !this.areProductPriceRecommendationsValidated;
  }

  isMenuEditable() {
    if (this.isPreviousPeriod) return false;
    return !this.isActive;
  }

  static applyTimeZoneOffset(date) {
    if (!date) return null;

    // Get the current offset of the user's timezone (in minutes)
    const userTimezoneOffset = date.getTimezoneOffset();

    // Calculate the offset difference between the user's timezone and Spain
    const spainTimezoneOffset = PredictionPeriod.getSpainTimezoneOffset(date);
    const offsetDifference = userTimezoneOffset - spainTimezoneOffset;

    // Adjust the original timestamp by adding the offset difference
    const adjustedTimestamp = date.getTime() + (offsetDifference * 60000);

    return new Date(adjustedTimestamp);
  }

  static getSpainTimezoneOffset(date) {
    const year = date.getFullYear();
    const dstStart = new Date(year, 2, 31 - (new Date(year, 2, 31)).getDay() + 1, 1, 0, 0); // Last Sunday of March
    const dstEnd = new Date(year, 9, 31 - (new Date(year, 9, 31)).getDay() + 1, 1, 0, 0); // Last Sunday of October

    if (date >= dstStart && date < dstEnd) {
      return -120;
    }
    return -60;
  }
}
